import { gql } from "@apollo/client";

export const FIND_USER_BY_ID_V5 = gql`
  query findUsersPermissionsUserByIdV5($documentId: ID!) {
    fetchMySchools(asRegularUser: false) {
      documentId
      name
      code
      logoMAT {
        url
        alternativeText
      }
      subscription {
        name
        knowledgeBase
        learn
        search
        bookmark
        mission
        podcast
        resourceHub
      }
    }
    usersPermissionsUser(documentId: $documentId) {
      id
      documentId
      username
      email
      provider
      confirmed
      blocked
      onboardHomeCompleted
      location
      forename
      surname
      confirmationEmailSent
      ageBracket
      gender
      onboardQuestionsCompleted
      isLeadershipWheelTrackingDisabled
      onboardLeadershipWheelCompleted
      # disableSwipeHint
      profile
      createdAt
      lastLoginAt
      lastLoginIp
      lastLoginUserAgent
      previousLoginAt
      previousLoginIp
      previousLoginUserAgent
      school {
        documentId
        name
        logoMAT {
          url
          alternativeText
        }
        subscription {
          name
          knowledgeBase
          learn
          search
          bookmark
          mission
          podcast
          resourceHub
        }
      }
      access_control_list {
        name
        isInstructor
        isMAT
        reportingTools
        manageStaff
      }
      createdAt
      photo {
        url
        alternativeText
      }
    }
  }
`;

export const PROFILE_PAGE_V5 = gql`
  query profilePageV5 {
    profilePage {
      welcomeTitle
      latestResourcesDownloadedTitle
      noDownloadedResourcesMessage
      profileInfoSection {
        roleTitle
        memberSinceTitle
        youLocationTitle
        editYourInfoCta
        saveYourChangesCta
        surnamePlaceholder
        forenamePlaceholder
        lastSignInTitle
        unrecognisedActivityMessage
      }
      profilePasswordSection {
        yourPasswordTitle
        yourCurrentPasswordField
        yourNewPasswordField
        confirmYourPasswordField
        confirmYourChangesCta
      }
      profileNotificationsSection {
        yourNotificationsTitle
        confirmYourChangesCta
      }
      profileSubTraitsSection {
        yourFocusTitle
        whichAreasTitle
        confirmYouChangesCta
      }
      traitTrackingSection {
        title
        btnStopTrackingLabel
        btnStartTrackingLabel
        notRecordedLabel
        notRecordedDescription
        notRecordedIcon {
          url
          alternativeText
        }
        notTrackingIcon {
          url
          alternativeText
        }
      }
      statsAndStreaks {
        finishingCardStreak {
          days
          title
        }
        finishingCardMaxStreak {
          days
          title
        }
        finishingCardLeadershipWheel {
          traits
        }
      }
    }
  }
`;
